module.exports = __webpack_public_path__ + "image/person_img1.png";